import React from 'react';
import TableEmptyState from '@shared/components/TableEmptyState';
import { TableNoSearchResultsProps } from './TableNoSearchResults.type';

const TableNoSearchResults: React.FC<TableNoSearchResultsProps> = ({
  buttonText,
  clickHandler,
  ...props
}) => (
  <TableEmptyState
    materialProps={props}
    label="No search results"
    pictureHeight="50px"
    pictureWidth="55px"
    picturePath="/images/no-search-results.svg"
    buttonText={buttonText}
    clickHandler={clickHandler}
  />
);

export default TableNoSearchResults;
